import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import type * as Widgets from '@orcha/micro-library-widgets-ui';

// All widgets-ui components live in one shared bundle — one helper covers them
const lib = (name: keyof typeof Widgets) =>
  dynamic(() =>
    import('@orcha/micro-library-widgets-ui').then(
      (m) => m[name] as ComponentType
    )
  );

export const widgetSelector = {
  // local widgets (default exports)
  appCardList: dynamic(() => import('./AppCardList')),
  appFeature: dynamic(() => import('./AppFeature')),
  carousel: dynamic(() => import('./Carousel')),
  hero: dynamic(() => import('./Hero')),
  twoColumnVideo: dynamic(() => import('./TwoColumnVideo')),
  heroV2: dynamic(() => import('./HeroV2')),
  verify: dynamic(() => import('./Verified/VerifiedWidget')),
  appFeatureList: dynamic(() =>
    import('./AppFeatureList').then((m) => m.AppFeatureList)
  ),

  // widgets-ui (shared bundle)
  accordion: lib('AccordionWidget'),
  buttons: lib('ButtonsWidget'),
  callToAction: lib('CallToActionWidget'),
  campaignHero: lib('CampaignHeroWidget'),
  copyHero: lib('CopyHeroWidget'),
  multiCard: lib('MultiCardWidget'),
  multiImagePanel: lib('MultiImagePanelWidget'),
  multiPanel: lib('MultiPanelWidget'),
  oneColumnHtml: lib('OneColumnHtmlWidget'),
  threeColumnHtml: lib('ThreeColumnHtmlWidget'),
  twoColumnContent: lib('TwoColumnContentWidget'),
  twoColumnImage: lib('TwoColumnImageWidget'),
  twoColumnHtml: lib('TwoColumnHtmlWidget'),

  // client-only
  powerbi: dynamic(() => import('./PowerBI'), { ssr: false }),
};
